export default __webpack_public_path__ + "static/media/service-license-flow.cde63060.png";